import { render, staticRenderFns } from "./TextBody.vue?vue&type=template&id=091a6e6c&scoped=true&lang=pug"
import script from "./TextBody.vue?vue&type=script&lang=ts"
export * from "./TextBody.vue?vue&type=script&lang=ts"
import style0 from "./TextBody.vue?vue&type=style&index=0&id=091a6e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091a6e6c",
  null
  
)

export default component.exports